import { FormGroup, FormLabel } from "react-bootstrap";
import styled from "styled-components";
import { Typeahead } from "react-bootstrap-typeahead";
import CircleXMark from "../../assets/icons/CircleXMark.svg";

const StyledLabel = styled(FormLabel)`
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #787878;
    margin: 0;
    margin-bottom: 0;
`;

const StyledFormSelect = styled(Typeahead)`
    height: 48px;
    box-sizing: border-box;
    border-radius: 0.375rem;
    .form-control {
        border: 1px solid #787878;
        &:focus {
            border-color: #9654ff;
            box-shadow: none;
        }
        &:hover {
            border-color: #9654ff;
            box-shadow: none;
        }
    }
    .btn-close {
        background: white url(${CircleXMark}) center/1em auto no-repeat;
        background-color: white;
        opacity: 85%;
    }
    .btn-close rbt-close {
        margin-top: 0px;
    }
    .dropdown-menu {
        background-color: #f0f2f2;
        margin-top: 2px;
        border: 1px solid #787878;
    }
    .dropdown-item {
        padding: 10px;
    }
`;

const StyledFormCombo = styled(Typeahead)`
    height: 48px;
    box-sizing: border-box;
    border-radius: 0.375rem;
    .form-control {
        border: 1px solid #787878;
        font-size: 15px;
        padding-top: 15px;
        &:focus {
            border-color: #9654ff;
            box-shadow: none;
        }
        &:hover {
            border-color: #9654ff;
            box-shadow: none;
        }
    }
    .btn-close {
        background: white url(${CircleXMark}) center/1em auto no-repeat;
        background-color: white;
        opacity: 85%;
    }
    .btn-close rbt-close {
        margin-top: 0px;
    }
    .dropdown-menu {
        background-color: #f0f2f2;
        margin-top: 2px;
        border: 1px solid #787878;
    }
    .dropdown-item {
        padding: 10px;
    }
`;

const StyledFormComboEmpty = styled(Typeahead)`
    height: 48px;
    box-sizing: border-box;
    border-radius: 0.375rem;
    .form-control {
        border: 1px solid #787878;
        &:focus {
            border-color: #9654ff;
            box-shadow: none;
        }
        &:hover {
            border-color: #9654ff;
            box-shadow: none;
        }
    }
    .btn-close {
        background: white url(${CircleXMark}) center/1em auto no-repeat;
        background-color: white;
        opacity: 85%;
    }
    .btn-close rbt-close {
        margin-top: 0px;
    }
    .dropdown-menu {
        background-color: #f0f2f2;
        margin-top: 2px;
        border: 1px solid #787878;
    }
    .dropdown-item {
        padding: 10px;
    }
`;

const StyledFormSelectClean = styled(Typeahead)`
    height: 48px;
    box-sizing: border-box;
    border-radius: 0.375rem;
    .form-control {
        border-width: 0px 0px 1px 0px;
        border-color: #787878;
        border-radius: 0;
        padding-top: 20px;
        &:focus {
            border-color: #9654ff;
            box-shadow: none;
        }
        &:hover {
            border-color: #9654ff;
            box-shadow: none;
        }
    }
    .btn-close {
        background: white url(${CircleXMark}) center/1em auto no-repeat !important;
        background-color: white;
        opacity: 85%;
    }
    .btn-close rbt-close {
        margin-top: 0px;
    }
    .dropdown-menu {
        background-color: #f0f2f2;
        margin-top: 2px;
        border: 1px solid #787878;
    }
    .dropdown-item {
        padding: 10px;
    }
`;

const StyledFormSelectFloatLabel = styled(Typeahead)`
    height: 48px;
    box-sizing: border-box;
    border-radius: 0.375rem;
    .form-control {
        border-style: solid;
        border: 1px solid #787878;
        border-radius: 4px;
        padding-top: 20px;
        font-size: 15px;
        &:focus {
            border-color: #9654ff;
            box-shadow: none;
        }
        &:hover {
            border-color: #9654ff;
            box-shadow: none;
        }
    }
    .btn-close {
        background: white url(${CircleXMark}) center/1em auto no-repeat;
        background-color: white;
        opacity: 85%;
    }
    .dropdown-menu {
        background-color: #f0f2f2;
        margin-top: 2px;
        border: 1px solid #787878;
    }
    .dropdown-item {
        padding: 10px;
    }
`;

const StyledFormSelectFloatLabelClean = styled(Typeahead)`
    height: 48px;
    box-sizing: border-box;
    border-radius: 0.375rem;
    .form-control {
        border-style: solid;
        border: 1px solid #787878;
        border-radius: 0px;
        padding-top: 20px;
        font-size: 15px;
        border-width: 0px 0px 1px 0px;
        &:focus {
            border-color: #9654ff;
            box-shadow: none;
        }
        &:hover {
            border-color: #9654ff;
            box-shadow: none;
        }
    }
    .btn-close {
        background: white url(${CircleXMark}) center/1em auto no-repeat;
        background-color: white;
        opacity: 85%;
    }
    .dropdown-menu {
        background-color: #f0f2f2;
        margin-top: 2px;
        border: 1px solid #787878;
    }
    .dropdown-item {
        padding: 10px;
    }
`;

const StyledFormGroup = styled(FormGroup)`
    position: relative;
    input {
        border: 0;
        border-bottom: 2px solid lightgrey;
        outline: none;
        min-width: 180px;
        font-size: 16px;
        transition: all 0.3s ease-out;
        -webkit-transition: all 0.3s ease-out;
        -moz-transition: all 0.3s ease-out;
        -webkit-appearance: none;
        border-radius: 0;
    }
    label {
        pointer-events: none;
        position: absolute;
        top: 4px;
        left: 0;
        margin-left: 13px;
        transition: all 0.3s ease-out;
        -webkit-transition: all 0.3s ease-out;
        -moz-transition: all 0.3s ease-out;
        z-index: 10;
    }
`;

export default {
    StyledLabel,
    StyledFormSelect,
    StyledFormSelectClean,
    StyledFormSelectFloatLabel,
    StyledFormSelectFloatLabelClean,
    StyledFormGroup,
    StyledFormCombo,
    StyledFormComboEmpty,
};
